// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"e798d0eb","192":"992a3c22","871":"208f444c"}[chunkId] + ".chunk.js";
};